<template>
  <div class="list-view InvoiceView_vue font-jumperlight">
<!--    feltoltesek tab -->
    <b-overlay
        :show="loading"
        rounded="sm"
        spinner-variant="success"
        spinner-type="grow"
    >
      <div class="list-wrapper mt-5" id="g3">
        <div v-if="listData && listData.length > 0">
          <div
              class="list-item my-2 d-flex p-3 mb-3"
              v-for="(item, index) in listData"
              :key="'listViewItem' + index"
              @click="rowClickable && redirectToDetailView(item.id)"
              :class="rowClickable ? 'cursor-pointer' : ''"
          >
            <b-container fluid class="">
              <div>
                <div class="list-label flex-fill">
                  <b-row class="invoice-label">
                    <b-col
                        class="width-0 ellipsis-overflow"
                        v-if="!!item.originalName"
                    >
                      {{ item.originalName }}
                    </b-col>
                    <b-col class="width-0 ellipsis-overflow" v-else>
                      {{ item.name }}
                    </b-col>
                    <b-col cols="2" class="">
                      <div class="list-button-wrapper">
                        <div
                            class="w-90 p-2 small text-nowrap rounded-pill uploaded"
                        >
                          <BIcon class="" :icon="'circle-fill'"/>
                          <span class="d-none d-md-inline ml-2">Feltöltve</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="d-block justify-content-start">
                    <div class="d-flex justify-content-start">
                      <div class="invoice-date">
                        <span>{{ parseDate(item.createdOn) }}</span>
                      </div>
                    </div>
                    <div class="d-flex justify-content-start ml-2">
                      <div v-for="tag in getDateTagsAsObject(item.tags)" :key="tag.id" class="mx-1 mt-3">
                        <span
                            class="tag-item bg-white rounded-pill p-2"
                        >
                          {{ tag.name }}
                        </span>
                      </div>
                      <div class="mx-1 mt-3">
                        <span
                            v-for="tag in getNonDateTagsAsObject(item.tags)" :key="tag.id"
                            class="tag-item bg-white rounded-pill p-2"
                        >
                          {{ tag.name }}
                        </span>
                      </div>
                    </div>
                  </b-row>
                </div>

              </div>
            </b-container>
          </div>
        </div>

        <div v-else class="mx-auto mb-2 text-center">
          {{
            searchTerm
                ? $cte("common.noSearchResult") + searchTerm
                : 'Még nem rögzítettél számlát'
          }}
        </div>
      </div>

      <Paging
          v-if="listData && listData.length > 0"
          :item-per-page="pageSize"
          :total-rows="totalNumberOfElements"
          @paging-change="updateTable"
      />
    </b-overlay>
  </div>
</template>

<script>
import Api from "api-client";
import {mapGetters} from "vuex";
import Paging from "./Paging";

export default {
  name: "InvoiceView",
  emits: ["noFilterLoad"],
  components: {
    Paging,
  },
  props: {
    rowClickable: {
      type: Boolean,
      default: true,
    },
    detailView: {
      type: String,
    },
    searchTerm: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      itemsPerPage: 10,
      windowWidth: window.innerWidth,
      listData: [],
      page: 1,
      pageSize: 10,
      totalNumberOfElements: 0,
      loading: false,
      maxNameLength: 14,
    };
  },
  methods: {
    getDateTagsAsObject() {
      return [];
    },

    getNonDateTagsAsObject(tagList) {
      return tagList;
    },

    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },

    parseDate(data) {
      let d = new Date(data),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear(),
          hours = "" + d.getHours(),
          minutes = "" + d.getMinutes();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      if (hours.length < 2) hours = "0" + hours;
      if (minutes.length < 2) minutes = "0" + minutes;

      return [year, month, day].join("-") + " " + [hours, minutes].join(":");
    },

    updateTable(data) {
      this.page = data.pagingPage;
      this.pageSize = data.pagingOffset;
      this.updateListData();
    },

    redirectToDetailView(id) {
      if (this.detailView) {
        this.$router.push(this.detailView + "/" + id);
      }
    },

    updateListData() {
      if (this.getActiveCompany) {
        this.loading = true;

        let companyId = this.getActiveCompany.id;
        if (companyId) {
          Api.getFilesOfCompany(companyId, this.type, this.page - 1, this.pageSize, this.searchTerm)
              .then((resp) => {
                this.loading = false;
                this.listData = resp.data.content;
                this.totalNumberOfElements = resp.data.totalNumberOfElements;

                if (!this.searchTerm) {
                  this.$emit("noFilterLoad", resp.data.totalNumberOfElements);
                }
              })
              .catch(() => {
                this.loading = false;
                this.$toast.error({
                  title: this.$cte("listView.queryFailedTitle"),
                  message: this.$cte("listView.queryFailedMessage"),
                });
              });
        }
      }
    },
  },
  created() {
    this.updateListData();
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  watch: {
    currentPage: {
      handler: function () {
        this.updateListData();
      },
    },
    searchTerm() {
      this.page = 1;
      this.updateListData();
    },
  },
};
</script>

<style scoped>
.width-0 {
  width: 0;
}

.ellipsis-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.max-content-width {
  width: max-content;
}

.empty-list-image {
  width: 75px;
}

.done {
  background-color: #5bb65d;
  color: white;
}

.deleted {
  background-color: #ffe2e5;
  color: #fb4f5c;
}

.uploaded {
  background-color: #A9E953;
  color: black;
}

.filled {
  background-color: green;
  color: white;
}

.stuck {
  background-color: #FFC500;
  color: black;
}

.tag {
  height: max-content;
  font-size: 12px;
}

.pagination-display-text {
  font-weight: lighter;
  color: #80808f;
}

.pagination-display-text:hover {
  text-decoration: none;
  color: #5bb65d;
}

.list-item {
  background-color: #AEBFC7;
  border: none !important;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10) !important;
}


.list-button-wrapper {
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

.invoice-label {
  font-size: 1.2rem;
}

.invoice-date {
  font-size: 0.8rem;
  color: #252734;
  margin-right: 3px;
  margin-left: 14px;
}

.list-button {
  width: 100px;
  text-align: center;
  border: none;
  border-radius: 5px;
  cursor: default;
}

.list-button.read {
  background-color: #fff4de;
  color: #ffa800;
}

.list-button.unread {
  background-color: #ffe2e5;
  color: #f64e60;
}

.list-button.filed {
  background-color: #fff4de;
  color: #ffa800;
}

.list-button.jam {
  background-color: #ffe2e5;
  color: #f64e60;
}

.list-button.booked {
  background-color: #c6f7f5;
  color: #1bc5bd;
}

.tag-item {
  max-width: max-content;
  font-size: 0.8rem !important;
  border-radius: 8px;
  padding: 0 10px;
  margin-right: 4px;
}
</style>
